import React from 'react';


export const GridItem = ({ tipoTable, columna, indexC, classNameRow, handleClickCheck,
    handleDblClick, checkRows, columnasRender,handleShow }) => {

    return (
        dataItems(tipoTable, columna, indexC, classNameRow,
            handleClickCheck, handleDblClick, checkRows, columnasRender,handleShow)
    );
}

function dataItems(tipoTable, columna, indexC, classNameRow, handleClickCheck,
    handleDblClick, checkRows, columnasRender,handleShow) {

    switch (tipoTable) {
        case "general":

            let keyRow;
            let idRow;
            let classRow;
            let actionOnDoubleClick;
            
            if (columnasRender) {

                for (let ind = 0; ind <= columnasRender.length; ind++) {
                    if (columnasRender[ind]) {

                        if (columnasRender[ind].key && keyRow === undefined) {
                            keyRow = columnasRender[ind].key;
                        }

                        if (columnasRender[ind].id && idRow === undefined) {
                            idRow = columnasRender[ind].id;
                        }

                        if (columnasRender[ind].classRow && classRow === undefined) {
                            classRow = columnasRender[ind].classRow;
                        }

                        if (columnasRender[ind].actionOnDoubleClick && actionOnDoubleClick === undefined) {
                            actionOnDoubleClick = columnasRender[ind].actionOnDoubleClick;
                        }

                    }
                }

                keyRow = keyRow ? `${keyRow}-${indexC}` : indexC;
                idRow = idRow ? idRow(columna) : `idRow-${indexC}`;
                classRow = classRow ? classRow : (classNameRow ? classNameRow : "");
                actionOnDoubleClick = actionOnDoubleClick ? actionOnDoubleClick : (() => { });

                // eslint-disable-next-line array-callback-return
                const itemsRow = columnasRender.map((colInfo, index) => {
                    const idCol = colInfo.name ? `${colInfo.name}-${indexC}-${index}` : `${indexC}-${index}`;
                    const nameCol = colInfo.name ? colInfo.name : "";
                    const classCol = colInfo.className ? colInfo.className : "table-text-center";
                    
                    const checkColClass = colInfo.check ? "select" : "";
                    const renderCol = colInfo.render ? colInfo.render : (val) => { return (val) };
                    const valueCol = columna?.[colInfo.name] !== null && columna?.[colInfo.name] !== undefined ? columna[colInfo.name] : "";
                    
                    if (nameCol) {
                        return (
                            <td key={`${indexC}-${index}`} id={idCol} className={`${checkColClass} ${classCol} `}>
                                {
                                    renderCol(valueCol, columna)
                                }
                            </td>
                        );
                    }

                });

                return (
                    <tr key={keyRow} id={idRow} className={`data-grid-item ${classRow}`}
                        data-object={JSON.stringify(columna)} onDoubleClick={() => {
                            actionOnDoubleClick(columna)
                        }} >
                        {itemsRow}
                    </tr>
                );

            }
            break;

        
        default:

    }

}







